import { render, staticRenderFns } from "./PopupAddVenueNote.vue?vue&type=template&id=70352dec&scoped=true&"
import script from "./PopupAddVenueNote.vue?vue&type=script&lang=js&"
export * from "./PopupAddVenueNote.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddVenueNote.vue?vue&type=style&index=0&id=70352dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70352dec",
  null
  
)

export default component.exports